import { CLOSE_INSTALL_APP_MODAL, OPEN_INSTALL_APP_MODAL } from './types';

const initialState = { isOpen: false };

export default (state = initialState, { type }) => {
  if (type === OPEN_INSTALL_APP_MODAL) {
    return { ...state, isOpen: true };
  }

  if (type === CLOSE_INSTALL_APP_MODAL) {
    return { ...state, isOpen: false };
  }

  return state;
};
